export const CARD_W = 320;
export const CARD_H = 162;

export function boxFor(task, sizes) {
  const measured = sizes?.get?.(task?.id);
  if (measured?.w > 0 && measured?.h > 0) return measured;
  return {
    w: task?.width || CARD_W,
    h: task?.height || CARD_H,
  };
}

export function taskPosition(task, index) {
  if (Number.isFinite(task?.x) && Number.isFinite(task?.y)) {
    return { x: task.x, y: task.y };
  }
  const col = index % 6;
  const row = Math.floor(index / 6);
  return { x: col * (CARD_W + 48), y: row * (CARD_H + 48) };
}

export function buildPositions(tasks) {
  const positions = new Map();
  (tasks || []).forEach((task, index) => {
    if (!task?.id) return;
    positions.set(task.id, taskPosition(task, index));
  });
  return positions;
}

export function screenToWorld(sx, sy, camera) {
  const zoom = camera.zoom || 1;
  return {
    x: (sx - camera.x) / zoom,
    y: (sy - camera.y) / zoom,
  };
}

export function worldToScreen(wx, wy, camera) {
  const zoom = camera.zoom || 1;
  return {
    x: wx * zoom + camera.x,
    y: wy * zoom + camera.y,
  };
}

export function hitTest(tasks, positions, world, sizes) {
  for (let i = tasks.length - 1; i >= 0; i -= 1) {
    const task = tasks[i];
    const pos = positions.get(task.id);
    if (!pos) continue;
    const box = boxFor(task, sizes);
    if (
      world.x >= pos.x
      && world.x <= pos.x + box.w
      && world.y >= pos.y
      && world.y <= pos.y + box.h
    ) {
      return task.id;
    }
  }
  return null;
}

export function fitCamera(tasks, positions, width, height, sizes) {
  if (!tasks.length || width < 1 || height < 1) {
    return { x: 48, y: 48, zoom: 1 };
  }
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  tasks.forEach((task) => {
    const pos = positions.get(task.id);
    if (!pos) return;
    const box = boxFor(task, sizes);
    minX = Math.min(minX, pos.x);
    minY = Math.min(minY, pos.y);
    maxX = Math.max(maxX, pos.x + box.w);
    maxY = Math.max(maxY, pos.y + box.h);
  });
  if (!Number.isFinite(minX)) return { x: 48, y: 48, zoom: 1 };
  const worldW = Math.max(1, maxX - minX);
  const worldH = Math.max(1, maxY - minY);
  const zoom = Math.max(0.15, Math.min(1, (width - 96) / worldW, (height - 96) / worldH));
  return {
    x: (width - worldW * zoom) / 2 - minX * zoom,
    y: (height - worldH * zoom) / 2 - minY * zoom,
    zoom,
  };
}
